export default "__VITE_ASSET__BCek7BGI__"